import React from "react";
import { Link } from "react-router-dom";
import { Mail, MapPin, Phone, ArrowUpRight } from "lucide-react";
import { EISG } from "@/constants/testIds";
import EISGLogo from "@/components/shared/EISGLogo";

const EISGFooter = () => {
  return (
    <footer data-testid={EISG.footer} className="bg-[#060D18] text-white grain">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-24 relative">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <EISGLogo variant="full" tone="light" />
            <p className="text-white/70 text-base leading-relaxed max-w-md font-body italic mt-8">
              "Gouverner l'IA. Piloter la transformation. Créer de la valeur."
            </p>
            <p className="text-white/55 text-sm leading-relaxed max-w-md font-body mt-3">
              Former les leaders. Outiller les métiers. Transformer l'Afrique.
            </p>
            <Link to="/" className="mt-8 inline-flex items-center gap-2 text-sm font-bold text-[#F58220] hover:text-[#D4AF37] tracking-wide">
              Visiter BridgeDatum <ArrowUpRight size={14} />
            </Link>
          </div>

          <div className="md:col-span-3">
            <div className="overline text-[#D4AF37] mb-4">Naviguer</div>
            <ul className="space-y-2.5 text-sm">
              {[
                ["/eisg/about", "À propos"],
                ["/eisg/programmes", "Programmes"],
                ["/eisg/cohorts", "Cohortes"],
                ["/eisg/advisory", "Advisory & In-House"],
                ["/eisg/experience", "Experience"],
                ["/eisg/investment", "Investment"],
                ["/eisg/registration", "Registration"],
                ["/eisg/contact", "Contact"],
              ].map(([h, l]) => (
                <li key={h}>
                  <Link to={h} className="text-white/70 hover:text-[#D4AF37] transition-colors">{l}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="overline text-[#D4AF37] mb-4">Contact</div>
            <ul className="space-y-3 text-sm text-white/80">
              <li className="flex items-start gap-3">
                <MapPin size={16} className="mt-0.5 text-[#D4AF37]" />
                <span>Centurion, South Africa · Johannesburg · Cape Town</span>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={16} className="mt-0.5 text-[#D4AF37]" />
                <a href="mailto:contact@bridgedatum.com" className="hover:text-[#D4AF37]">contact@bridgedatum.com</a>
              </li>
              <li className="flex items-start gap-3">
                <Phone size={16} className="mt-0.5 text-[#D4AF37]" />
                <a href="https://wa.me/27836274861" className="hover:text-[#D4AF37]">WhatsApp +27 83 627 4861</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-white/50">
          <div>© {new Date().getFullYear()} EISG · A BridgeDatum Institute. Tous droits réservés.</div>
          <div className="tracking-[0.2em] uppercase">IA · Gouvernance · Transformation</div>
        </div>
      </div>
    </footer>
  );
};

export default EISGFooter;
